/**
 *
 *
 * Name,
 * Cell,
 * Land
 * Email
 * Public info
 * Instructions
 * Date Last Changed
 *
 * */

import {Input} from "antd";
import {maxLengthInput, maxLengthTextArea} from "../../utils/constants";
import {html_space} from "../../utils/space";
import * as React from "react";
import TextArea from "antd/es/input/TextArea";
import {contactInfoType} from "./contactInfoType";
import {DateLastChanged} from "./date-last-changed";

interface IProps {
    infoType: contactInfoType;
    contactValid: boolean;
    contactInfo: any;
    updateContactKey: any;
    validateContactKey: any;
    getValidationMessage: any;
}

export function NewContactPopup ({infoType, contactValid, contactInfo, updateContactKey, validateContactKey, getValidationMessage}: IProps) {
    // const {name, cell, land, email, instruc, pubconfinfo, datelastchanged} = this.state.contactInfo;
    const textAreaKeys: {[key: string]: string} = {
        pubconinfo: 'Public Info',
        instruc: 'Instructions',
    }
    const keys: {[key: string]: string} = {
        name: 'Name',
        cell: 'Cell',
        land: 'Land',
        email: 'Email',
        ...textAreaKeys,
    };

    const phoneKeys: {[key: string]: string} = React.useMemo(() => ({
        cell: 'Cell',
        land: 'Land',
    }), []);

    const _updateContactKey = React.useCallback((key, e) => {
        if (!phoneKeys[key]) return updateContactKey(key, e);
        e.target.value = e.target.value.replace(/[^0-9-]/, '').replace(/(\d{3})-?(\d{3})-?(\d{4})/,'$1-$2-$3');
        updateContactKey(key, e);
    }, [phoneKeys, updateContactKey]);

    if (!contactInfo) {
        return null;
    }

    return <div>
        {Object.keys(keys).map((key, index) =>
            <div key={`vert-modal-index-${index}`} className="modal-input">
                <div> {keys[key]}</div>
                {
                    !textAreaKeys[key] ?
                        !phoneKeys[key] ?
                            <Input size={'small'} maxLength={maxLengthInput}
                                   value={contactInfo[key] || ''} onChange={(e) => _updateContactKey(key, e)}/> :
                            <Input size={'small'} maxLength={12}
                                   value={contactInfo[key] || ''} onChange={(e) => _updateContactKey(key, e)}/> :
                        <TextArea autoSize
                                  maxLength={maxLengthTextArea}
                                  value={contactInfo[key] || ''}
                                  onChange={(e) => updateContactKey(key, e)}/>
                }
                {(!contactValid && !validateContactKey(key)) &&
                <div className={'modal-input-error'}>
                    {html_space()}Invalid value for {keys[key]} - {getValidationMessage(key)}
                </div>
                }
            </div>
        )}
        {infoType === contactInfoType.DETAILS_EDIT &&
        contactInfo && contactInfo.datelastchanged &&
        <div>
            <DateLastChanged date={contactInfo.datelastchanged}/>
        </div>}
    </div>
}